export const UK_POSTCODE_REGEXP = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/;
export const DD_MM_YYYY_REGEXP = /^[0-9]{2}[\\/]{1}[0-9]{2}[\\/]{1}[0-9]{4}$/g; // format: DD/MM/YYYY
export const EMAIL_REGEXP = /^\S+@\S+\.\S+$/;
